import { Component } from '@angular/core';
import { AppService } from '@shared/services/app.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-product-detail-report-discrepancies',
  templateUrl: './product-detail-report-discrepancies.component.html',
  styleUrls: ['./product-detail-report-discrepancies.component.scss'],
})
export class ProductDetailReportDiscrepanciesComponent {
  constructor(private appService: AppService) {}

  reportDiscrepancies() {
    this.appService.getCustomFeedback(
      'report-discrepancies-new',
      true,
      environment.usabillaCampaingIdReportDiscrepancy,
    );
  }
}
